<template>
   <!-- 标签 -->
  <span v-if="statusName||getStatusName" class="workBench-tag" :class="`workBench-type${type}-tag${status||''}`">{{statusName?statusName:getStatusName}}</span>
</template>
<script>
export default {
  props: ['status', 'type', 'statusName','sign'],
  data () {
    return {
      typeObj:{
        // 采购商项目：
        '1': {
          '10': '已保存',
          '20': '待审批',
          '30': '初始化已完成',
          '40': '已失效',
          '50': '已完成',
          '9800': '已废弃'
        },
        // 需求申请：
        '2': {
          '10': '已保存',
          '20': '待审批',
          '30': '已驳回',
          '40': '已审批',
          '50': '已生效',
          '60': '作废待审批',
          '70': '已作废',
          '80': '已撤回'
        },
        // 合同
        '3': {
          '10': '已保存',
          '15': '待审批',
          '20': '审批中',
          '30': '审批驳回',
          '40': '已生效',
          '50': '变更审批中',
          '60': '失效'
        },
        // 供应商项目：
        '4': {
          '5000': '报名通过',
          '5001': '回标中',
          '20  ': '待接收邀请',
          '40  ': '报名已驳回',
          '1200': '报名信息已接收',
          '1201': '报名审核中',
          '2   ': '待接受邀请',
          '6010': '授标中',
          '5060': '商务已回标',
          '1600': '报名已退回',
          '5040': '商务回标中',
          '8010': '成交通知书待发送',
          '5020': '已回标',
          '3200': '招标文件购买审核中',
          "3000": '招标文件购买中'
        },
        '5': {

        // 订单状态
          '1000': '未下单',
          '1500': '待审批',
          '2000': '待供应商确认',
          '3000': '待采购商确认',
          '4000': '待发货',
          '4010': '部分发货待收货',
          '4020': '全部发货待收货',
          '5000': '已完成',
          '5010': '部分发货已收货',
          '6000': '已评价',
          '7000': '已关闭',
          '9000': '已取消',
          '9500': '审批驳回'
        },
        // 我发起的申请 
            
        // 需求系统 sign=xq 我发起的申请   108：已保存;109:审批中;110:审批驳回;111:采购中;112采购已分配;113已关闭；114 已撤回；123:已退回
        // 采招系统 sign=cz 我发起的申请   10  已保存 20  待审批 30  已驳回  40  已审批  50  已生效  60  作废待审批  70  已作废  80  已撤回
      // workBench-typexqfq-tag108 已保存
      // workBench-typexqfq-tag109 审批中
      // workBench-typexqfq-tag110 审批驳回
      // workBench-typexqfq-tag111 采购中
      // workBench-typexqfq-tag112 采购已分配
      // workBench-typexqfq-tag113 已关闭
      // workBench-typexqfq-tag114 已撤回
      // workBench-typexqfq-tag123 已退回
        'xqfq':{
          '108':'已保存',
          '109':'审批中',
          '110':'审批驳回',
          '111':'采购中',
          '112':'采购已分配',
          '113':'已关闭',
          '114':'已撤回',
          '123':'已退回'
        },
      // workBench-typeczfq-tag10 已保存
      // workBench-typeczfq-tag20 待审批
      // workBench-typeczfq-tag30 已驳回
      // workBench-typeczfq-tag40 已审批
      // workBench-typeczfq-tag50 已生效
      // workBench-typeczfq-tag60 作废待审批
      // workBench-typeczfq-tag70 已作废
      // workBench-typeczfq-tag80 已撤回
        'czfq':{
          '10':'已保存', 
          '20':'待审批', 
          '30':'已驳回',  
          '40':'已审批',  
          '50':'已生效',  
          '60':'作废待审批',  
          '70':'已作废',  
          '80':'已撤回',
        },
        // 我处理的申请 
        // 需求系统	sign=xq    我处理的申请   1  待处理
        // 采招系统  sign=cz	我处理的申请   10 待确定（供应商数量）
        
      // workBench-typexqcl-tag1 待处理
        'xqcl':{
          '1':'待处理'
        },
      // workBench-typeczcl-tag10 待确定
        'czcl':{
          '10':'待确定'
        },
        // 我创建的合同
        
          // 合同系统 sign=ht     我创建的合同   10  已保存 20审批中 30审批驳回 40已生效 50变更审批中 60失效	
          // 采招系统 sign=cz 我创建的合同   10  已保存 15  待审批 20  已归档 30  审批驳回

          
      // workBench-typehtcj-tag10 已保存
      // workBench-typehtcj-tag20 审批中
      // workBench-typehtcj-tag30 审批驳回
      // workBench-typehtcj-tag40 已生效
      // workBench-typehtcj-tag50 变更审批中
      // workBench-typehtcj-tag60 失效
        'htcj':{
          '10':'已保存',
          '20':'审批中',
          '30':'审批驳回', 
          '40':'已生效', 
          '50':'变更审批中', 
          '60':'失效'
        },
        
      // workBench-typeczcj-tag10 已保存
      // workBench-typeczcj-tag15 待审批
      // workBench-typeczcj-tag20 已归档
      // workBench-typeczcj-tag30 审批驳回
        'czcj':{
          '10':'已保存',
          '15':'待审批',
          '20':'已归档',
          '30':'审批驳回'
        }
      }
    }
  },
  created () {
    
  },
  computed:{
      


  // 采购商项目：
  //   10  已保存   workBench-type1-tag10
  //   20  待审批   workBench-type1-tag20
  //   30  初始化已完成   workBench-type1-tag30
  //   40  已失效   workBench-type1-tag40
  //   50  已完成   workBench-type1-tag50
  //   9800    已废弃   workBench-type1-tag9800

  // 需求申请：
  //   10  已保存  workBench-type2-tag10
  //   20  待审批  workBench-type2-tag20
  //   30  已驳回  workBench-type2-tag30
  //   40  已审批  workBench-type2-tag40
  //   50  已生效  workBench-type2-tag50
  //   60  作废待审批 workBench-type2-tag60
  //   70  已作废 workBench-type2-tag70
  //   80  已撤回 workBench-type2-tag80

  // 合同：
  //   10  已保存 workBench-type3-tag10
  //   15  待审批 workBench-type3-tag15
  //   20  已归档 workBench-type3-tag20
  //   30  审批驳回 workBench-type3-tag30

  // 合同状态 
    // 10  已保存 workBench-type3-tag10
  //   15  待审批 workBench-type3-tag15
    // 20  审批中 workBench-type3-tag20
    // 30  审批驳回 workBench-type3-tag30

    // 40  已生效 workBench-type3-tag40
    // 50  变更审批中 workBench-type3-tag50
    // 60  失效 workBench-type3-tag60
  // 订单
  
    // 1000 未下单 workBench-type5-tag1000
    // 1500 待审批 workBench-type5-tag1500
    // 2000 供应商待确认 workBench-type5-tag2000
    // 3000 采购商待确认 workBench-type5-tag3000
    // 4000 待发货 workBench-type5-tag4000
    // 4010 部分发货待收货 workBench-type5-tag4010
    // 4020 全部发货待收货 workBench-type5-tag4020
    // 5000 已完成 workBench-type5-tag1000
    // 5010 部分发货已收货 workBench-type5-tag5010
    // 6000 已评价 workBench-type5-tag6000
    // 7000 已关闭 workBench-type5-tag7000
    // 9000 已取消 workBench-type5-tag9000
    // 9500 审批驳回 workBench-type5-tag9500
  /* 我发起的申请  */
  /* workBench-typexqfq-tag108 已保存
  workBench-typexqfq-tag109 审批中
  workBench-typexqfq-tag110 审批驳回
  workBench-typexqfq-tag111 采购中
  workBench-typexqfq-tag112 采购已分配
  workBench-typexqfq-tag113 已关闭
  workBench-typexqfq-tag114 已撤回
  workBench-typexqfq-tag123 已退回

  workBench-typeczfq-tag10 已保存
  workBench-typeczfq-tag20 待审批
  workBench-typeczfq-tag30 已驳回
  workBench-typeczfq-tag40 已审批
  workBench-typeczfq-tag50 已生效
  workBench-typeczfq-tag60 作废待审批
  workBench-typeczfq-tag70 已作废
  workBench-typeczfq-tag80 已撤回 */

  /* 我处理的申请  */
  /*         
    workBench-typexqcl-tag1 待处理
    workBench-typeczcl-tag10 待确定 
  */

  /* 我创建的合同 */
        
  /* workBench-typehtcj-tag10 已保存
  workBench-typehtcj-tag20 审批中
  workBench-typehtcj-tag30 审批驳回
  workBench-typehtcj-tag40 已生效
  workBench-typehtcj-tag50 变更审批中
  workBench-typehtcj-tag60 失效

  workBench-typeczcj-tag10 已保存
  workBench-typeczcj-tag15 待审批
  workBench-typeczcj-tag20 已归档
  workBench-typeczcj-tag30 审批驳回 */

  // 供应商项目：
    getStatusName(){
      // console.info(this.type,this.status,this.typeObj[this.type][this.status])
      return this.typeObj[this.type]&&this.typeObj[this.type][this.status]
    }
  },
  methods: {

  }
}
</script>
<style>
.workBench-tag{
  position: relative;
  display: inline-block;
  padding-left:15px;
  padding-right: 6px;
  font-size: 12px;
  color: #606266;
  text-align: left;
  line-height: 18px;
  border: 1px solid #DCDFE6;
  border-radius: 3px;
  border-radius: 3px;
}
.workBench-tag:after{
  content:"";
  position: absolute;
  left:6px;
  top:50%;
  margin-top: -2px;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background: #C4C8CE;

}
/* 进行中，已保存,待办，成功，拒绝 */

/* 进行中 */
/* 
  5001    回标中 workBench-type4-tag5001
  6010    授标中     workBench-type4-tag6010
  5040    商务回标中 workBench-type4-tag5040
  
  3200    招标文件购买审核中 workBench-type4-tag3200
  3000    招标文件购买中 workBench-type4-tag3000
  1201    报名审核中 workBench-type4-tag1201

  5010 部分发货已收货 workBench-type5-tag5010
  1000 未下单 workBench-type5-tag1000

  50  变更审批中 workBench-type3-tag50


  workBench-typexqfq-tag109 审批中
  workBench-typexqfq-tag111 采购中
  workBench-typehtcj-tag20 审批中
  workBench-typehtcj-tag50 变更审批中

  
  workBench-typexqfq-tag109 审批中
  workBench-typexqfq-tag111 采购中
  workBench-typehtcj-tag20 审批中
  workBench-typehtcj-tag50 变更审批中

   */

.workBench-type4-tag5001,
.workBench-type4-tag6010,
.workBench-type4-tag5040,
.workBench-type4-tag1201,
.workBench-type3-tag50,
.workBench-typexqfq-tag109,
.workBench-typexqfq-tag111,
.workBench-typehtcj-tag20,
.workBench-typehtcj-tag50,
.workBench-type4-tag3200,
.workBench-type4-tag3000{
  color: #55A0F5;
  border-color: #90BCF2;
}

.workBench-type4-tag5001:after,
.workBench-type4-tag6010:after,
.workBench-type4-tag5040:after,
.workBench-type4-tag1201:after,
.workBench-type3-tag50:after,
.workBench-typexqfq-tag109:after,
.workBench-typexqfq-tag111:after,
.workBench-typehtcj-tag20:after,
.workBench-typehtcj-tag50:after,
.workBench-type4-tag3200:after,
.workBench-type4-tag3000:after{
  background: #65A0E6;
}

/* 已保存 */
/*
  10  已保存   workBench-type1-tag10
  50  已完成   workBench-type1-tag50

  5000    报名通过 workBench-type4-tag5000
  1200    报名信息已接收 workBench-type4-tag1200
  5060    商务已回标 workBench-type4-tag5060
  5020    已回标 workBench-type4-tag5020

  30  初始化已完成   workBench-type1-tag30


  5000 已完成 workBench-type5-tag1000
  6000 已评价 workBench-type5-tag6000

  40  已生效 workBench-type3-tag40
  
  1200    报名信息已接收 workBench-type4-tag1200

  
  workBench-typexqfq-tag108 已保存
  workBench-typeczfq-tag10 已保存
  workBench-typexqfq-tag112 采购已分配
  workBench-typexqfq-tag113 已关闭
  workBench-typexqfq-tag114 已撤回
  workBench-typexqfq-tag123 已退回
  workBench-typeczfq-tag40 已审批
  workBench-typeczfq-tag50 已生效
  workBench-typeczfq-tag70 已作废
  workBench-typeczfq-tag80 已撤回
  workBench-typehtcj-tag10 已保存
  workBench-typehtcj-tag40 已生效
  workBench-typeczcj-tag10 已保存
  workBench-typeczcj-tag20 已归档
  workBench-typeczfq-tag30 已驳回
   */

.workBench-type1-tag10,
.workBench-type1-tag50,
.workBench-type4-tag5000,
.workBench-type4-tag1200,
.workBench-type4-tag5060,
.workBench-type4-tag5020,
.workBench-type1-tag30,
.workBench-type5-tag1000,
.workBench-type5-tag6000,
.workBench-type3-tag40,
.workBench-typexqfq-tag108,
.workBench-typeczfq-tag10,
.workBench-typexqfq-tag112,
.workBench-typexqfq-tag113,
.workBench-typexqfq-tag114,
.workBench-typexqfq-tag123,
.workBench-typeczfq-tag40,
.workBench-typeczfq-tag50,
.workBench-typeczfq-tag70,
.workBench-typeczfq-tag80,
.workBench-typehtcj-tag10,
.workBench-typehtcj-tag40,
.workBench-typeczcj-tag10,
.workBench-typeczcj-tag20,
.workBench-typeczfq-tag30{
  color: #606266;
  border-color: #DCDFE6;
}

.workBench-type1-tag10:after,
.workBench-type1-tag50:after,
.workBench-type4-tag5000:after,
.workBench-type4-tag1200:after,
.workBench-type4-tag5060:after,
.workBench-type4-tag5020:after,
.workBench-type1-tag30:after,
.workBench-type5-tag1000:after,
.workBench-type5-tag6000:after,
.workBench-type3-tag40:after,

.workBench-typexqfq-tag108:after,
.workBench-typeczfq-tag10:after,
.workBench-typexqfq-tag112:after,
.workBench-typexqfq-tag113:after,
.workBench-typexqfq-tag114:after,
.workBench-typexqfq-tag123:after,
.workBench-typeczfq-tag40:after,
.workBench-typeczfq-tag50:after,
.workBench-typeczfq-tag70:after,
.workBench-typeczfq-tag80:after,
.workBench-typehtcj-tag10:after,
.workBench-typehtcj-tag40:after,
.workBench-typeczcj-tag10:after,
.workBench-typeczcj-tag20:after,
.workBench-typeczfq-tag30:after{
  background: #C4C8CE;
}

/* 待办 */

/* 
  20  待审批   workBench-type1-tag20

  20  待审批  workBench-type2-tag20
  60  作废待审批 workBench-type2-tag60

  15  待审批 workBench-type3-tag15

  20      待接收邀请 workBench-type4-tag20
  8010    成交通知书待发送 workBench-type4-tag8010
  2       待接受邀请 workBench-type4-tag2 

    1500 待审批 workBench-type5-tag1500
    2000 供应商待确认 workBench-type5-tag2000
    3000 采购商待确认 workBench-type5-tag3000
    4000 待发货 workBench-type5-tag4000
    4010 部分发货待收货 workBench-type5-tag4010
    4020 全部发货待收货 workBench-type5-tag4020


  workBench-typexqcl-tag1 待处理
  workBench-typeczcl-tag10 待确定 
  workBench-typeczfq-tag20 待审批
  workBench-typeczcj-tag15 待审批
  workBench-typeczfq-tag60 作废待审批
*/

  .workBench-type1-tag20,
  .workBench-type2-tag20,
  .workBench-type2-tag60,
  .workBench-type3-tag15,
  .workBench-type4-tag20,
  .workBench-type4-tag8010,
  .workBench-type4-tag2,
  .workBench-type5-tag1500,
  .workBench-type5-tag2000,
  .workBench-type5-tag3000,
  .workBench-type5-tag4000,
  .workBench-type5-tag4010,
  .workBench-type5-tag4020,
  .workBench-typexqcl-tag1,
  .workBench-typeczcl-tag10, 
  .workBench-typeczfq-tag20,
  .workBench-typeczcj-tag15,
  .workBench-typeczfq-tag60{
  color: #F2AA3C;
  border-color: #F2AA3C;
}

.workBench-type1-tag20:after,
.workBench-type2-tag20:after,
.workBench-type2-tag60:after,
.workBench-type3-tag15:after,
.workBench-type4-tag20:after,
.workBench-type4-tag8010:after,
.workBench-type4-tag2:after,
.workBench-type5-tag1500:after,
.workBench-type5-tag2000:after,
.workBench-type5-tag3000:after,
.workBench-type5-tag4000:after,
.workBench-type5-tag4010:after,
.workBench-type5-tag4020:after,
.workBench-typexqcl-tag1:after,
.workBench-typeczcl-tag10:after, 
.workBench-typeczfq-tag20:after,
.workBench-typeczcj-tag15:after,
.workBench-typeczfq-tag60:after{
  background: #F2AA3C;
}
/* 成功 */

/* 
  10  已保存  workBench-type2-tag10
  40  已审批  workBench-type2-tag40
  50  已生效  workBench-type2-tag50

  10  已保存 workBench-type3-tag10

  20  已归档 workBench-type3-tag20
*/

.workBench-type2-tag10,
.workBench-type2-tag40,
.workBench-type2-tag50,
.workBench-type3-tag10,
.workBench-type3-tag20{
  color: #76CC76;
  border-color: #76CC76;
}

.workBench-type2-tag10:after,
.workBench-type2-tag40:after,
.workBench-type2-tag50:after,
.workBench-type3-tag10:after,
.workBench-type3-tag20:after{
  background: #76CC76;
}
/* 拒绝 */

/* 
  40  已失效   workBench-type1-tag40
  9800    已废弃   workBench-type1-tag9800

  30  已驳回  workBench-type2-tag30
  70  已作废 workBench-type2-tag70
  80  已撤回 workBench-type2-tag80

  30  审批驳回 workBench-type3-tag30

  40      报名已驳回 workBench-type4-tag40
  1600    报名已退回 workBench-type4-tag1600

  7000 已关闭 workBench-type5-tag7000
  9000 已取消 workBench-type5-tag9000
  9500 审批驳回 workBench-type5-tag9500

  60  失效 workBench-type3-tag60

  

  workBench-typexqfq-tag110 审批驳回
  workBench-typehtcj-tag30 审批驳回
  workBench-typehtcj-tag60 失效
  workBench-typeczcj-tag30 审批驳回
*/
.workBench-type1-tag40,
.workBench-type1-tag9800,
.workBench-type2-tag30,
.workBench-type2-tag70,
.workBench-type2-tag80,
.workBench-type3-tag30,
.workBench-type4-tag40,
.workBench-type4-tag1600,
.workBench-type5-tag7000,
.workBench-type5-tag9000,
.workBench-type5-tag9500,
.workBench-type3-tag60,
.workBench-typexqfq-tag110,
.workBench-typehtcj-tag30,
.workBench-typehtcj-tag60,
.workBench-typeczcj-tag30{
  color: #F77777;
  border-color: #F77777;
}
.workBench-type1-tag40:after,
.workBench-type1-tag9800:after,
.workBench-type2-tag30:after,
.workBench-type2-tag70:after,
.workBench-type2-tag80:after,
.workBench-type3-tag30:after,
.workBench-type4-tag40:after,
.workBench-type4-tag1600:after,
.workBench-type5-tag7000:after,
.workBench-type5-tag9000:after,
.workBench-type5-tag9500:after,
.workBench-type3-tag60:after,
.workBench-typexqfq-tag110:after,
.workBench-typehtcj-tag30:after,
.workBench-typehtcj-tag60:after,
.workBench-typeczcj-tag30:after{
  background: #F77777;
}

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/tag.vue